<template>
    <a class="nav-item" :href="url">
        <div class="nav-item__icon">
            <slot name="icon"></slot>
        </div>

        <div class="nav-item__title">
            {{ title }}
        </div>
    </a>
</template>

<script>
export default {
    props: [
        'title',
        'icon',
        'url',
    ]
}
</script>
